(function () {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('EnvResultDet', EnvResultDet);

    EnvResultDet.$inject = ['$resource'];

    function EnvResultDet($resource) {
        var resourceUrl = 'api/env-result-dets/:id';

        return $resource(resourceUrl, {}, {
            'get': {method: 'GET', isArray: true}
        });
    }
})();
